import { getLink } from "../../common/generic_functions";

export const getReportingLinks = (name) => {
  return getLink("reports", LINKS, name);
};

const LINKS = [
  {
    name: "getReportsFromWS",
    link: "get-reports/",
    description: "get-reports/<ws_id:str>/ --> Array with all reports from a WS, the user have access",
  },
  { name: "getAllWS", link: "get-all-workspaces/", description: "Array with all WS, the user have access" },
  { name: "singeReport", link: "get-report/", description: "get-report/<ws_id:str>/<report_id:str>/ --> embedded object" },
  { name: "getTemplates", link: "get-templates/", description: "get-templates/<str:report_type>/ --> get templates!" },
  { name: "getPages", link: "get-pages/", description: "get-pages/<str:report_id>/ --> get pages!" },
  { name: "getCampaigns", link: "get-campaigns-for-client/", description: "get-campaigns-for-client/<str:workspace_id>/ --> get campaigns!" },
  { name: "addReport", link: "clone-report/", description: "clone-report/<str:report_id>/ --> clones a report as a template" },
  { name: "getEditReportTemplateSettings", link: "get-edit-report-template/", description: "get-edit-report-template/<str:report_id>/" },
  { name: "getEditReportSharedSettings", link: "get-edit-report-shared/", description: "get-edit-report-shared/<str:report_id>/" },
  { name: "updateReportingTemplate", link: "update-report/", description: "update-report/<str:report_id>/" },
  { name: "shareReport", link: "share-report/", description: "share-report/<str:report_id>/" },
  { name: "workSapceTagApi", link: "workspace-tag/", description: "workspace-tag/<str:workspace_id>/" },
  { name: "reportTag", link: "report-tag/", description: "report-tag/<str:report_id>/" },
];
